const socialCopy = $(".social-copy");
const socialTool = $(".social-tools")


if (socialCopy) {
  socialCopy.addEventListener("click", function(e) {
    e.preventDefault();
    const href = window.location.href;
    const prompt = window.prompt("Click OK to copy the following to your clipboard.", href);

    if (prompt) {
      window.navigator.clipboard.writeText(prompt);
    }
  });
}

if (socialTool) {
  const url = document.location.href;
  const title = document.title;
  const facebook = socialTool.querySelector(".share-facebook");
  const x = socialTool.querySelector(".share-x");
  const linkedin = socialTool.querySelector(".share-linkedin");

  facebook.href = facebook.href + `?u=${encodeURIComponent(url)}&t=${encodeURIComponent(title)}`;
  linkedin.href = linkedin.href + `?mini=true&url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`;
  x.href = x.href + `?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`;
}